import { defineComponent as _defineComponent } from 'vue'
import CloseIcon from '@/assets/svg/close.vue.svg';
import Success from '@/components/partials/war-room/WarRoomJobApplicationBanner/assets/success.vue.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomJobApplicationBanner',
  setup(__props) {

const bullets = [
  'Network with over 200k sales professionals',
  'Earn commission for contributing',
  'Exchange commission for real rewards',
];

return { __sfc: true,bullets, CloseIcon, Success }
}

})